import React from "react";
import { AllWaitingQueue } from "./waitingQueue";
import { Title } from "../../components/Title";

const CallsWaitingQueue: React.FC = () => {
    return (
        <>
            <Title title="Telefonata në linjë"></Title>
            <AllWaitingQueue />
        </>
    );
};

export default CallsWaitingQueue;
